import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import signUpNotificationsIcon from '../../../assets/SignUpNotifications.svg';
import { selectCurrentEmpid } from '../../../pages/login/authSlice';
import { AboutMeModel } from '../aboutMe/about-me-service';
import { useCreateUpdateAboutMeMutation, useGetAboutMePersonalizationQuery } from '../aboutMe/aboutMeSlice';
import './signUpNotification.scss';

export const SignUpNotification = () => {
    const empId = useSelector(selectCurrentEmpid);
    const [aboutMe, setAboutMe] = useState<any>([]);
    const [createUpdateAboutMe] = useCreateUpdateAboutMeMutation();
    const [aboutMeEmail, setAboutMeEmail] = useState<string>('');
    const [aboutMePhone, setAboutMePhone] = useState<number | string>('');
    const [enableSubmit, setEnableSubmit] = useState<boolean>(false);
    const [validEmail, setValidEmail] = useState<boolean>(true);
    /* eslint-disable no-useless-escape */
    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const { data: aboutMeData } = useGetAboutMePersonalizationQuery(
        { employeeNumber: empId },
        { skip: !empId }
    );

    const onEmailChange = (e: any) => {
        setAboutMeEmail(e.target.value);
        if (!isValidEmail.test(e.target.value)) {
            setValidEmail(false);
        } else {
            setValidEmail(true);
        }
    };

    const Submit = () => {
        const aboutMeObj: AboutMeModel = {
            personalizationId: aboutMe?.personalization_id ? aboutMe?.personalization_id : 0,
            aboutMeDescription: aboutMe?.about_me_description ? aboutMe?.about_me_description : '',
            empLanguageId: aboutMe?.emp_language_id ? aboutMe?.emp_language_id : null,
            employeeNumber: empId,
            emailAddress: aboutMeEmail,
            phoneNumber: aboutMePhone.toString(),
        };

        createUpdateAboutMe(aboutMeObj)
            .unwrap()
            .then(() => {
                toast.success('Saved Successfully');
            })
            .catch((error: any) => {
                console.error(error);
                toast.error('Saved Failed');
            });
    };

    useEffect(() => {
        const isFormValid = validEmail && aboutMePhone !== null && aboutMePhone !== '';
        setEnableSubmit(isFormValid);
    }, [aboutMePhone, validEmail]);

    useEffect(() => {
        if (aboutMeData?.data.length > 0) {
            setAboutMe(aboutMeData?.data[0]);
            setAboutMeEmail(aboutMeData?.data[0]?.email_address);
            setAboutMePhone(aboutMeData?.data[0]?.phone_number);
        }
    }, [aboutMeData]);

    return (
        <div style={{ height: '454px', width: '672px' }}>
            <div className="row">
                <div id="signUpLeftBox" className="col-md-6 border-end">
                    <div>
                        <div className="signUpLeftBoxText">
                            Sign up for notifications and never <br />
                            miss out on important updates!
                        </div>
                        <img
                            className="signUpNotificationsIcon"
                            src={signUpNotificationsIcon}
                            alt="Sign Up Notifications"
                        />
                    </div>
                </div>
                <div id="signUpRightBox" className="col-md-6">
                    <h5 className="mb-3" style={{ fontSize: '24px' }}>
                        Sign Up
                    </h5>
                    <div className="row mt-3">
                        <div className="col-md-11">
                            <div className="flex flex-column gap-2">
                                <label htmlFor="email_address">Email</label>
                                <InputText
                                    id="email_address"
                                    className={`borderRadius w-100 ${validEmail ? '' : 'p-invalid'} `}
                                    aria-describedby="email_address-help"
                                    placeholder="Enter email here"
                                    value={aboutMeEmail}
                                    onChange={onEmailChange}
                                />
                                {validEmail ? null : (
                                    <label id="error-message" htmlFor="email_address" className="text-danger">
                                        Invalid email address
                                    </label>
                                )}
                            </div>
                            <div className="flex flex-column gap-2 mt-3">
                                <label htmlFor="phone_number">Phone Number*</label>
                                <InputText
                                    id="phone_number"
                                    aria-describedby="phone_number-help"
                                    placeholder="Enter phone number here"
                                    value={aboutMePhone}
                                    maxLength={25}
                                    keyfilter={/^([/0-9]|[/0-9]?%)$/}
                                    className={`borderRadius w-100 ${aboutMePhone === '' ? 'p-invalid' : ''}`}
                                    onChange={(e) => setAboutMePhone(e.target.value)}
                                />
                                <small id="phone_number-help">*Message and data rates may apply</small>
                            </div>
                        </div>
                    </div>
                    <div className="right-align">
                        <Button
                            id="signUpButton"
                            label="Sign Up Now"
                            onClick={Submit}
                            disabled={!enableSubmit}
                            className="p-button p-component mt-5 w-100"
                            style={{ borderRadius: '12px' }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
